/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Arrow key incrementation in editor",
  "description": "Use the up and down arrow keys to increase or decrease number values in numeric input fields such as those in blocks or the sprite properties area.",
  "tags": [
    "recommended"
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Change on regular key press",
      "id": "regular",
      "type": "select",
      "default": "one",
      "potentialValues": [
        {
          "id": "none",
          "name": "None"
        },
        {
          "id": "hundredth",
          "name": "0.01"
        },
        {
          "id": "tenth",
          "name": "0.1"
        },
        {
          "id": "one",
          "name": "1"
        },
        {
          "id": "ten",
          "name": "10"
        }
      ],
      "if": {
        "settings": {
          "useCustom": false
        }
      }
    },
    {
      "dynamic": true,
      "name": "Change on regular key press",
      "id": "regularCustom",
      "type": "untranslated",
      "default": "1",
      "max": 8,
      "if": {
        "settings": {
          "useCustom": true
        }
      }
    },
    {
      "dynamic": true,
      "name": "Change on Shift+Key",
      "id": "shift",
      "type": "select",
      "default": "ten",
      "potentialValues": [
        {
          "id": "none",
          "name": "None"
        },
        {
          "id": "hundredth",
          "name": "0.01"
        },
        {
          "id": "tenth",
          "name": "0.1"
        },
        {
          "id": "one",
          "name": "1"
        },
        {
          "id": "ten",
          "name": "10"
        }
      ],
      "if": {
        "settings": {
          "useCustom": false
        }
      }
    },
    {
      "dynamic": true,
      "name": "Change on Shift+Key",
      "id": "shiftCustom",
      "type": "untranslated",
      "default": "10",
      "max": 8,
      "if": {
        "settings": {
          "useCustom": true
        }
      }
    },
    {
      "dynamic": true,
      "name": "Change on Alt+Key",
      "id": "alt",
      "type": "select",
      "default": "tenth",
      "potentialValues": [
        {
          "id": "none",
          "name": "None"
        },
        {
          "id": "hundredth",
          "name": "0.01"
        },
        {
          "id": "tenth",
          "name": "0.1"
        },
        {
          "id": "one",
          "name": "1"
        },
        {
          "id": "ten",
          "name": "10"
        }
      ],
      "if": {
        "settings": {
          "useCustom": false
        }
      }
    },
    {
      "dynamic": true,
      "name": "Change on Alt+Key",
      "id": "altCustom",
      "type": "untranslated",
      "default": "0.1",
      "max": 8,
      "if": {
        "settings": {
          "useCustom": true
        }
      }
    },
    {
      "dynamic": true,
      "name": "Use custom values",
      "id": "useCustom",
      "type": "boolean",
      "default": false
    }
  ],
  "credits": [
    {
      "name": "mybearworld",
      "link": "https://scratch.mit.edu/users/mybearworld/"
    },
    {
      "name": "World_Languages"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
